module.exports = __webpack_public_path__ + "img/sh-nike-marathon-2016-1.e143c5af.jpg";